// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { useSiteMetadata } from '../hooks/use-site-metadata'

interface SEOProps {
  title?: string
  description?: string
  children?: any
}

export const SEO: React.FC<SEOProps> = ({ title, description, children }) => {
  const {
    title: defaultTitle,
    siteTitle,
    description: defaultDescription,
    image,
    siteUrl,
    orgDescription
  } = useSiteMetadata()

  const seo = {
    title: title ?? defaultTitle,
    siteTitle,
    description: description ?? defaultDescription,
    image,
    url: siteUrl,
    orgDescription
  }

  return (
    <>
      <html lang="en" />
      <title>{seo.title}</title>
      <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-touch-icon.png" />
      <link rel="icon" href="/images/favicon.ico" />
      <link rel="icon" type="image/png" sizes="32x32" href="/images/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/images/favicon-16x16.png" />
      <link rel="mask-icon" href="/images/safari-pinned-tab.svg" color="#16CFB1" />
      <meta name={seo.siteTitle} content={seo.orgDescription} />
      <meta httpEquiv="x-dns-prefetch-control" content="on" />
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.siteTitle} />
      <meta property="og:description" content={seo.description} />
      <meta name="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.siteTitle} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {children}
    </>
  )
}
